import React from 'react';
import { View, Text } from 'react-native';
import LottieView from 'lottie-react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { MODERN_CHART_COLORS } from '@utils/chartTheme';
import ModernChartWrapper from './ModernChartWrapper';

interface ProgressChartProps {
  isLoading?: boolean;
}

const ProgressChart: React.FC<ProgressChartProps> = ({
  isLoading = false
}) => {
  const theme = themeSelector();
  const summaryData = [
    { label: 'Data Usage', value: '65%', color: MODERN_CHART_COLORS.line.primary },
    { label: 'Storage', value: '45%', color: MODERN_CHART_COLORS.line.secondary },
    { label: 'AI Calls', value: '78%', color: MODERN_CHART_COLORS.line.tertiary }
  ];

  const loadingComponent = (
    <LottieView
      style={{ height: 150, alignSelf: 'center' }}
      source={require("@assets/animations/spin-leaf-loader.json")}
      autoPlay
      loop
    />
  );

  return (
    <ModernChartWrapper
      title="Usage Progress"
      subtitle="Track your usage across different metrics"
      isLoading={isLoading}
      loadingComponent={loadingComponent}
      summaryData={summaryData}
      minHeight={320}
      minWidth={340}
    >
      <View style={{
        height: 180,
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Text style={{
          fontSize: 14,
          textAlign: 'center',
          color: theme ? '#666' : '#aaa',
          marginBottom: 20
        }}>
          Progress visualization coming soon
        </Text>
        <View style={{
          width: 100,
          height: 100,
          borderRadius: 50,
          backgroundColor: theme ? '#f0f0f0' : '#333',
          alignItems: 'center',
          justifyContent: 'center',
          borderWidth: 4,
          borderColor: theme ? '#ddd' : '#555'
        }}>
          <Text style={{
            fontSize: 12,
            color: theme ? '#666' : '#aaa',
            textAlign: 'center'
          }}>
            Coming Soon
          </Text>
        </View>
      </View>
    </ModernChartWrapper>
  );
};

export default ProgressChart;
